import React from 'react';
import filterObserver from '../observer/FilterService';
import Skeleton from 'react-loading-skeleton';
import { LazyImage } from "react-lazy-images";


const WarningMessage = function(props) {
  if (!props.show) return null;

  const style = {
    background: '#fffde3',
    width: '100%',
    padding: '10px',
    borderRadius: '0.5em',
    marginBottom: '3px'
  };
  return <div style={{...props.style, ...style}}>{props.children}</div>
}


export default class NearbyHospital extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected_hospital: null,
      warning_message: null,
      latitude: null,
      longitude: null
    }
    this.watchLocation = null;
  }

  componentDidMount() {
    /* once component launch */
    /* find nearby hospital */
    this.trackCurrentLocationUpdate((pos) => {
      /* realtime track current location */
      const { latitude, longitude } = pos.coords;
      const { oldLatitude, oldLongitude } = this.state;

      if (latitude != oldLatitude || longitude != oldLongitude) {
        /* only fetch new data if old position is differ then new one */
        this.fetchNearbyHospital(latitude, longitude);
      }
    }, (error) => {
      console.warn(`Error occurred: [${error.code}] ${error.message}`)
      this.setState({
        warning_message: 'Location acces denied, please allow this site to access your location to get nearby hospital'
      });
    });
  }

  componentWillUnmount() {
    /* stop listening location update */
    this.untrackCurrentLocationUpdate();
  }

  trackCurrentLocationUpdate(success, error) {
    if ("geolocation" in navigator) {
      /* geolocation is supported */
      console.log("geolocation: supported");
      console.log("start listening to location update...");
      this.watchLocation = navigator.geolocation.watchPosition(function(position) {
        /* notify new position */
        success(position);
      }, (err) => {
        /* error occurred */
        error(err);
      });
    } else {
      /* not supported */
      console.warn("geolocation: not available");
      this.setState({
        warning_message: 'GeoLocation is not supported by this device, cannot get nearby hospital',
      })
    }
  }

  untrackCurrentLocationUpdate() {
    if ("geolocation" in navigator && this.watchLocation != null) {
      console.log("stop listening to location update...");
      navigator.geolocation.clearWatch(this.watchLocation);
      this.watchLocation = null;
    }
  }


  fetchNearbyHospital(lat, lng){
    const _this = this;
    fetch(`${this.props.url}api/v1/public/hospitals/nearby?lat=${lat}&lng=${lng}`)
      .then(res => (res && res.status === 200 && res.ok ? res.json() : Promise.reject(res)))
      .then(res => {
        if (res.status && res.status == 200) {
          /* check hospital count */
          if (res.data.length > 0) {
            _this.setState({
              selected_hospital: res.data[0]
            });
          } else {
            _this.setState({
              warning_message: 'No hospital found in your area'
            });
          }
        } else {
          console.log('Api url is', this.props.api_ur)
          console.warning('Error while fetching nearby hospital', res);
          _this.setState({
            warning_message: 'Could not fetch nearby hospital'
          });
        }
      }).catch(res => {
        // error occurred
        console.warn('Error while fetching nearby hospital', res);
        _this.setState({
          warning_message: 'Could not fetch nearby hospital'
        });
      });
  }
  
  render() {
    const { warning_message, selected_hospital } = this.state;

    console.log('selected_hospital', selected_hospital)
    return(
      
      <div className="your-location mb-2">
        
        <div className="image-wrapper">
          {selected_hospital != null
            ? <img src="https://herminadev.s3-ap-southeast-1.amazonaws.com/your-location.svg" alt="image" className="imaged "/>
            : <Skeleton circle={true} height={40} width={40}/>
          }
          
        </div>
        <div className="in">
          {selected_hospital != null
            ? <strong dangerouslySetInnerHTML={{ __html: selected_hospital.attributes.name }}/>
            : <Skeleton height={12} width={`60%`}/>
          }
          {selected_hospital != null && selected_hospital.attributes.distance != null
            ? <div className="text-muted ellipsis">
                {selected_hospital.attributes.distance.toFixed(2)} KM dari lokasi anda
              </div>
            : <Skeleton height={12} width={`50%`}/>
          }
          {selected_hospital != null
            ? <div className="your-location-button">
                <img src="https://herminadev.s3-ap-southeast-1.amazonaws.com/arrow.svg" width="13" alt=""/>
              </div>
            : null
          }
          
        </div>
      </div>
    )
  }
}

